import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Group, GroupMembershipPotential } from "@shared/models/group"
import type NotifierService from "cc-frontend/services/notifier"
import type Rpc from "cc-frontend/services/rpc"
import type { group_add_individual_rpc_response } from "cc-frontend/services/rpc"
import { tracked } from "tracked-built-ins"

interface Signature {
  Args: {
    row: GroupMembershipPotential
    group: Group
  }
}

export default class GroupMembersTableActionsInvitePotentialCell extends Component<Signature> {
  @service declare rpc: Rpc
  @service declare notifier: NotifierService

  @tracked isExecutingRpc = false

  @action
  invitePotential() {
    this.isExecutingRpc = true

    // Invite the user.
    const email = this.args.row.attributes.cachedUserEmail
    this.rpc
      .group_add_individual({
        groupId: this.args.group.id,
        userId: this.args.row.attributes.userId,
        makeAdmin: this.args.row.attributes.roles.includes("group:is-admin"),
      })
      .then((response: group_add_individual_rpc_response) => {
        if (this.isDestroyed || this.isDestroying) {
          return
        } else {
          this.isExecutingRpc = false
        }

        if (response.responseOk === true) {
          this.notifier.success("", {
            title: `${email} was invited!`,
            message: "We're sending them an email right now.",
            duration: 3000,
          })
        } else {
          if (
            response.result.code === "USER_ALREADY_ADMIN" ||
            response.result.code === "USER_ALREADY_MEMBER"
          ) {
            this.notifier.warning("", {
              title: `${email} was already invited!`,
              message: "They should have an email in their inbox",
              duration: 3000,
            })
          }
        }
      })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Cells::ActionsInvitePotential": typeof GroupMembersTableActionsInvitePotentialCell
  }
}
